import { render, staticRenderFns } from "./audienceAssest.vue?vue&type=template&id=d8768228&scoped=true&"
import script from "./audienceAssest.vue?vue&type=script&lang=js&"
export * from "./audienceAssest.vue?vue&type=script&lang=js&"
import style0 from "./audienceAssest.vue?vue&type=style&index=0&id=d8768228&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8768228",
  null
  
)

export default component.exports